<template>
  <div class="wrap">
    <div class="pop">
      <i class="el-icon-close closeBtn" @click="close"></i>
      <p class="title">
        <span>{{ content.protocolTitle }}</span>
      </p>
      <div class="content" v-html="getXssIntro(content.protocolContent)"></div>
      <el-button class="confirmBtn" type="primary" :loading="confirming" :disabled="disabled" @click="confirm">{{ disabled ? '确认(' + time + 's)' : '确认' }}</el-button>
    </div>
  </div>
</template>
<script>
import { getXssIntro } from '@/utils/xss'
import { confirmChannelFeeChange } from '@/api/login'

export default {
  name: 'ChannelFeeNotice',
  data () {
    return {
      time: 0,
      timer: null,
      disabled: true,
      confirming: false,
      content: {}
    }
  },
  methods: {
    getXssIntro,
    // content: { protocolTitle, protocolContent, showTime }
    init (content) {
      clearInterval(this.timer)
      this.timer = null
      this.content = content || {}
      this.time = content && content.showTime ? content.showTime : 0
      this.disabled = this.time > 0
      if (this.time <= 0) return
      this.timer = setInterval(() => {
        if (this.time > 0) {
          this.time--
        } else {
          this.disabled = false
          clearInterval(this.timer)
        }
      }, 1000)
    },
    async confirm () {
      if (this.disabled || this.confirming) return
      this.confirming = true
      try {
        const { code, result } = await confirmChannelFeeChange()
        if (code !== 200 || result !== true) {
          this.$message.error('确认失败，请重试')
          return
        }
        this.$emit('confirm-success')
      } catch (error) {
        console.log(error)
      } finally {
        this.confirming = false
      }
    },
    // 关闭：仅关闭弹窗，不调确认接口
    close () {
      this.$emit('close')
    }
  },
  beforeDestroy () {
    clearInterval(this.timer)
  }
}
</script>
<style lang="less" scoped>
  .wrap {
    position: fixed;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.4);
    z-index: 2003;
    .pop {
      width: 900px;
      height: 600px;
      overflow-y: auto;
      background: #fff;
      position: absolute;
      top: calc(50% - 300px);
      left: calc(50% - 450px);
      box-shadow: 0px 12px 30px 0px rgba(0, 0, 0, 0.12);
      border-radius: 4px;
      padding: 0 20px;
      .closeBtn {
        position: absolute;
        top: 24px;
        right: 24px;
        font-size: 22px;
        color: #909399;
        cursor: pointer;
        z-index: 1;
        &:hover {
          color: #409eff;
        }
      }
      .title {
        text-align: center;
        height: 88px;
        line-height: 88px;
        font-weight: 700;
        color: #222222;
        font-size: 20px;
        margin: 0;
      }
      .content {
        color: #000000;
        height: 416px;
        overflow-y: auto;
        padding: 0 20px;
        white-space: pre-wrap;
        word-break: break-word;
        font-size: 15px;
        line-height: 32px;
        font-weight: 500;
        /deep/ img {
          max-width: 780px;
        }
      }
      .confirmBtn {
        display: block;
        width: 140px;
        border-radius: 4px;
        font-size: 14px;
        margin: 24px auto;
      }
      /deep/ .is-disabled {
        background-color: #a0cfff;
        border-color: #a0cfff;
      }
    }
  }
</style>
